<script setup>
const props = defineProps({
    modelValue: { type: [String, Number, null], default: null },
    label: { type: String, default: '' },
    items: { type: Array, default: () => [] },
    itemText: { type: String, default: 'name' },
    itemValue: { type: String, default: 'uuid' },
});
const emit = defineEmits(['update:modelValue', 'change']);

function select(value) {
    emit('update:modelValue', value);
    emit('change', value);
}
</script>
<template>
    <div class="mguu-radio-group">
        <div v-if="label" class="mguu-radio-group__label">{{ label }}</div>
        <div class="mguu-radio-group__options">
            <label
                v-for="item in items"
                :key="item[itemValue]"
                class="mguu-radio-group__option"
                :class="{
                    'mguu-radio-group__option--selected':
                        modelValue === item[itemValue],
                }"
            >
                <input
                    type="radio"
                    :name="'mguu-rg-' + label"
                    :value="item[itemValue]"
                    :checked="modelValue === item[itemValue]"
                    @change="select(item[itemValue])"
                    class="mguu-radio-group__input"
                />
                <span class="mguu-radio-group__circle"></span>
                <span class="mguu-radio-group__text">{{ item[itemText] }}</span>
            </label>
        </div>
    </div>
</template>
<style scoped lang="scss">
* {
    box-sizing: border-box;
}

.mguu-radio-group {
    display: flex;
    flex-direction: column;
    gap: 8px;

    &__label {
        font-size: 16px;
        line-height: 16px;
        font-weight: 500;
        color: #12122c;
    }

    &__options {
        display: flex;
        gap: 24px;
        flex-wrap: wrap;
        align-items: center;
    }

    &__input {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
        pointer-events: none;
    }

    &__option {
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        user-select: none;

        &--selected .mguu-radio-group__circle {
            border-color: rgba(242, 11, 54, 1);
            border-width: 8px;
        }
    }

    &__circle {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 2px solid #d4d3d9;
        background: #fff;
        flex-shrink: 0;
        transition:
            border-color 0.15s,
            border-width 0.15s;
    }

    &__text {
        font-size: 16px;
        line-height: 24px;
        color: #12122c;
        font-weight: 400;
    }
}
</style>
